import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    className: 'session-replay-thumbnail',

    events: {
        'click': 'onOpen'
    },

    dom_handlers: {
        onOpen: function(e) {
            if (!this.model.get('session_recording_id')) {
                return;
            }

            Modals.openSessionRecording(this.model.get('session_recording_id'), 0);
        }
    },

    render: function(options) {
        var content = '';

        content += '<span class="icon"><i class="fas fa-play-circle"></i></span><span class="text">Replay</span>';

        this.$el.html(content);

        if (!this.model.get('session_recording_id')) {
            this.$el.addClass('disabled tooltip').attr('data-title', 'No session replay captured');
        }

        return this;
    }
});